(function () {
  "use strict";

  var mainImage = document.querySelector("[data-codm-main-image]");
  document.querySelectorAll("[data-codm-thumb]").forEach(function (button) {
    button.addEventListener("click", function () {
      if (!mainImage) return;
      mainImage.src = button.dataset.codmThumb || "";
    });
  });

  var form = document.getElementById("cod-order-form");
  var appSlot = document.getElementById("codm-app-form-slot");
  var sticky = document.querySelector("[data-codm-sticky]");
  if (form && sticky && "IntersectionObserver" in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          sticky.classList.toggle("is-visible", !entry.isIntersecting);
        });
      },
      { threshold: 0.15 }
    );
    observer.observe(form);
  }

  document.querySelectorAll("[data-codm-scroll-form]").forEach(function (button) {
    button.addEventListener("click", function () {
      var target = form || appSlot;
      if (target) target.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  });
})();
